import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Button
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import L from "leaflet";

import "leaflet/dist/leaflet.css";
import { t } from "i18next";
import { setMobileBackColor, setMobileCardBorderColor, setMobileTextColor } from "../../utility";

import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Reverse geocode helper function
const reverseGeocode = async (lat, lng) => {
  const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`;
  const res = await fetch(url);
  const data = await res.json();
  return data.address;
};

function LocationSelector({ setLatLng, handleOpenLocationFormDailog, updateLocationFormData }) {
  useMapEvents({
    async click(e) {
      const { lat, lng } = e.latlng;
      setLatLng({ lat, lng });
      try {
        const address = await reverseGeocode(lat, lng);
        updateLocationFormData(address);
        handleOpenLocationFormDailog();
      } catch (error) {
        console.error("Reverse geocoding failed:", error);
      }
    },
  });
  return null;
}

export default function NewLocationPicker({
  openLocationFormDailog,
  latlangVal,
  updateLocationFormData,
  closeMapModal
}) {
  const [latLng, setLatLng] = useState(null);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const coords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        setLatLng(coords);

        const { lat, lng } = coords;

        try {
          const addr = await reverseGeocode(lat, lng);
          updateLocationFormData(addr);
        } catch (error) {
          console.warn("Initial geocode error:", error);
        }
      },
      (err) => {
        console.warn("Geolocation error:", err.message);
      }
    );
  }, []);

  const handleClose = () => {
    closeMapModal();
  };

  const handleOpenLocationFormDailog = () => {
    openLocationFormDailog();
    latlangVal(latLng);
  };

  return (
    <Dialog className="alignByLang" sx={{
      "& .MuiDialog-paper": {
        backgroundColor: setMobileBackColor(),
        color: setMobileTextColor(),
        border: `1px solid ${setMobileCardBorderColor()}`,
        borderRadius: 2,
      },
      "& .MuiDialogContent-root": {
        backgroundColor: setMobileBackColor(),
        color: setMobileTextColor(),
      },
    }} open fullWidth maxWidth="sm" onClose={handleClose}>
      <DialogTitle className="head-font" sx={{ m: 0, p: 2 }}>
        📍 {t("Pick a Location")}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={[{
            position: "absolute",
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }, localStorage.getItem("lang") === "ar" || localStorage.getItem("lang") === "fr" ? {
            left: 1
          } : {
            right: 1
          }]}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            width: "100%",
            height: 470,
            borderRadius: 2,
            border: "1px solid #ccc",
            mb: 2,
            overflow: "hidden",
          }}
        >
          {latLng ? (
            <>
              <MapContainer
                center={latLng}
                zoom={14}
                style={{ height: "400px", width: "100%" }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                />
                <Marker position={latLng} />
                <LocationSelector
                  setLatLng={setLatLng}
                  // handleOpenLocationFormDailog={handleOpenLocationFormDailog}
                  updateLocationFormData={updateLocationFormData}
                />
              </MapContainer>

              {latLng && (
                <Box mt={2} textAlign="center">
                  <Button
                    className="head-font"
                    variant="contained"
                    color="primary"
                    onClick={handleOpenLocationFormDailog}
                  >
                    {t("Continue")}
                  </Button>
                </Box>
              )}
            </>

          ) : (
            <Typography>{t("Loading location...")} </Typography>
          )}

        </Box>
      </DialogContent>
    </Dialog>
  );
}
